<template>
    <div class="card-body card-body--checkout card-body--padding--1">
        <h3 class="card-title">Billing Details</h3>
        <div class="form-row">
            <div class="form-group col-md-6">
                <label for="checkout-first-name">Customer</label>
                <p><strong>{{ name }}</strong><br>
                {{ fullAddress }}<br>
                    {{ city }}, {{ state }} {{ zip }}</p>
            </div>
            <div class="form-group col-md-6">
                <label for="checkout-first-name">Contact Information</label><br>
                <a href="javascript:void(0);">{{ email }}</a><br>
                {{ format_phone_no(phone) }}
            </div>
        </div>

        <div class="form-row">
            <div class="form-group col-md-6">
                <label for="checkout-email">Add New Email</label>
                <input type="email" class="form-control" id="checkout-email" placeholder="Email address" v-model.trim="newemail">
            </div>
            <div class="form-group col-md-6">
                <label for="checkout-phone">Add New Phone</label>
                <input type="text" class="form-control" id="checkout-phone" placeholder="Phone" v-model.trim="newphone">
            </div>
        </div>
    </div>
</template>

<script>
import Formatter from '../../../mixins/formatter.js';

export default {
    props: {
        name: {
            type: String
        },
        address1: {
            type: String
        },
        address2: {
            type: String
        },
        city: {
            type: String
        },
        state: {
            type: String
        },
        zip: {
            type: String
        },
        phone: {
        },
        email: {
            type: String
        },
    },
    mixins: [Formatter],
    data () {
        return {
            newemail: '',
            newphone: ''
        }
    },
    computed: {
        fullAddress() {
            if (this.address1 === '') {
                return this.address2;
            } else {
                return this.address1 + ' ' + this.address2
            }
        }
    },
    methods: {
        updateBillingDetails() {
            let cartemail = '', cartphone = '';

            cartemail = this.newemail === '' ? this.email : this.newemail;
            cartphone = this.newphone === '' ? this.phone : this.newphone;

            this.$store.dispatch('cart/billingdetails', {
                "email": cartemail,
                "phone": cartphone,
                "billingname": this.name,
                "billingaddress1": this.address1,
                "billingaddress2": this.address2,
                "billingcity": this.city,
                "billingstate": this.state,
                "billingcountry": "",
                "billingzip": this.zip,
                "billingphone": cartphone,
            });
        }
    },
    updated() {
        this.updateBillingDetails();
        this.format_phone_no(this.phone);
    },
    created() {
        this.newemail = '', this.newphone = '';
        
    }
}
</script>